import { ContainerModule } from 'inversify';
import SocketConnection from '@framework/di/Providers/Socket/Connection';
import { DispatcherFactory, type IDispatcherFactory } from '@drs/json-rpc-dispatcher';
import { ISocketAdapter, ISocketClient, ISocketConnection, ISocketDispatcher } from './interfaces';
import DITypes from './types';
import { SocketAdapter } from '../SocketAdapter';
import SocketClient from '../SocketClient';

export const SocketModule = new ContainerModule(({ bind }) => {
  bind<ISocketConnection>(DITypes.SocketConnection).to(SocketConnection).inSingletonScope();

  bind<ISocketAdapter>(DITypes.SocketAdapter).to(SocketAdapter).inSingletonScope();

  bind<IDispatcherFactory>(DITypes.DispatcherFactory).to(DispatcherFactory).inSingletonScope();

  bind<ISocketDispatcher>(DITypes.SocketDispatcher)
    .toDynamicValue(({ get }) => {
      const dispatcherFactory = get<IDispatcherFactory>(DITypes.DispatcherFactory);
      const socketAdapter = get<ISocketAdapter>(DITypes.SocketAdapter);
      return dispatcherFactory.create(socketAdapter);
    })
    .inSingletonScope();

  bind<ISocketClient>(DITypes.SocketClient).to(SocketClient).inSingletonScope();
});
